export default "__VITE_ASSET__fad587e2__"